import React from "react";
import { HiOutlineAcademicCap, HiOutlineBriefcase } from "react-icons/hi2";
import publicBankLogo from "../../assets/institutions/public-bank.png";
import ukmLogo from "../../assets/institutions/ukm.png";
import kmppLogo from "../../assets/institutions/kmpp.png";
const work = [
  {
    title: "Analyst Programmer",
    organisation: "Public Bank Berhad - IT Strategy & Architecture",
    period: "May 2024 - Present",
    logo: publicBankLogo,
    description:
      "Build and maintain mobile banking applications for MyPB, PB Enterprise, PBeXperience and PB Journey. Deliver secure financial features, API integrations and UI/UX designs; contribute to URD and TSD preparation; and serve as Scrum Master coordinating delivery through Jira and Slack. Built a Jenkins CI/CD pipeline for iOS and Android builds, testing and deployments.",
  },
  {
    title: "Intern Programmer",
    organisation: "Public Bank Berhad - Fintech & Digitalisation",
    period: "Sep 2023 - Feb 2024",
    logo: publicBankLogo,
    description:
      "Contributed to mobile feature delivery and production support, resolving defects and improving application reliability. Integrated Firebase Crashlytics and Google Analytics to support crash monitoring, error diagnosis and usage tracking.",
  },
];
const education = [
  {
    title: "Master of Computing (Artificial Intelligence)",
    organisation: "Universiti Kebangsaan Malaysia",
    period: "Sep 2025 - Present",
    logo: ukmLogo,
    description:
      "Research-based postgraduate study exploring artificial intelligence, machine learning and intelligent systems. The programme strengthens my ability to connect practical software development with emerging AI methods.",
  },
  {
    title: "Bachelor of Software Engineering",
    organisation: "Universiti Kebangsaan Malaysia - CGPA 3.71",
    period: "Oct 2020 - Aug 2024",
    logo: ukmLogo,
    description:
      "Information System Development specialisation, completed as a JPA scholarship holder. Built a foundation in software engineering practices, system analysis, development methodologies and collaborative project delivery.",
  },
  {
    title: "Physical Science Stream (Computer Science)",
    organisation: "Kolej Matrikulasi Pulau Pinang - CGPA 4.00",
    period: "Mar 2019 - Mar 2020",
    logo: kmppLogo,
    description:
      "Completed pre-university studies with a computer science focus, developing early strengths in analytical thinking, programming fundamentals and structured problem-solving.",
  },
];
const Column = ({ title, items, type }) => {
  const MarkerIcon =
    type === "work" ? HiOutlineBriefcase : HiOutlineAcademicCap;
  return (
    <div className="timeline-column">
      <h3>{title}</h3>
      {items.map((item, index) => (
        <article className="panel timeline-card" key={item.title}>
          <div className="timeline-mark">
            <MarkerIcon aria-hidden="true" />
            <span>{String(index + 1).padStart(2, "0")}</span>
          </div>
          <div>
            <h4>{item.title}</h4>
            <div className="meta">{item.organisation}</div>
            <div className="meta timeline-period">{item.period}</div>
            <p>{item.description}</p>
          </div>
        </article>
      ))}
    </div>
  );
};
const EducationExperience = () => (
  <section id="experience" className="section">
    <p className="eyebrow">Background</p>
    <h2 className="section-title">Experience & education</h2>
    <div className="timeline-grid">
      <Column title="Professional experience" items={work} type="work" />
      <Column title="Education" items={education} type="education" />
    </div>
  </section>
);
export default EducationExperience;
